import React, { Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable'
import axios from 'axios'
import { Card, Table, CardBody, Col, Button } from 'reactstrap'
import { baseURL } from '../../_helpers'
import { Link } from 'react-router-dom'
import * as moment from 'moment'
import Modal from 'react-modal';
import './style.css';
import { MDBCloseIcon } from "mdbreact"
import { TOKEN } from '../../_helpers/token'
import { CustomerCalledStatus } from './customerstatus'
import Select from 'react-select';
import '../users/style.css'
import { Alert } from 'bootstrap';
// import Modal from 'react-modal';
// import { MDBCloseIcon } from "mdbreact";


const options = [
    { value: 'Called', label: 'Called' },
    { value: 'Has Called', label: 'Has Called' },
    { value: 'Not Called', label: 'Not Called' }
];

const options_3 = [
    { value: 'Incoming call', label: 'Incoming call' },
    { value: 'Outgoing call', label: 'Outgoing Call' }
];

const options_2 = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Happy', label: 'Happy' },
    { value: 'Unhappy', label: 'Unhappy' },
    { value: 'Annoyed', label: 'Annoyed' }

];
export class UserDetails extends React.Component {
    constructor(props) {
        super(props)

        this.onSubmitQuery = this.onSubmitQuery.bind(this);
        this.onSubmitPlay = this.onSubmitPlay.bind(this);
       
        this.onSubmitPlayAirtel = this.onSubmitPlayAirtel.bind(this);
        this.onSubmitPlayTigo = this.onSubmitPlayTigo.bind(this);
        
        this.onSubmitWithdraw = this.onSubmitWithdraw.bind(this);
        this.onSubmitDeposit = this.onSubmitDeposit.bind(this);
        this.onSubmitPlayOnline = this.onSubmitPlayOnline.bind(this);
        this.onSubmitDepositTP = this.onSubmitDepositTP.bind(this);
        this.toggleModalCreate = this.toggleModalCreate.bind(this);
        this.onSubmitRemark = this.onSubmitRemark.bind(this);
        this.onSubmitRemarkUpdate = this.onSubmitRemarkUpdate.bind(this);

        this.onSubmitAfterCallingCustomer = this.onSubmitAfterCallingCustomer.bind(this);

        this.onSubmitAfterCustomerCalling = this.onSubmitAfterCustomerCalling.bind(this);


        this.onSubmitblacklist = this.onSubmitblacklist.bind(this);

        this.columns = [
            {
                key: 'id',
                TrOnlyClassName: 'tsc',
                text: 'id',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'phone',
                TrOnlyClassName: 'tsc',
                text: 'msisdn',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'email',
                TrOnlyClassName: 'tsc',
                text: 'Email',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'maccount',
                TrOnlyClassName: 'tsc',
                text: 'Account',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'mbalance',
                TrOnlyClassName: 'tsc',
                text: 'Balance',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'mjoiningKeyword',
                TrOnlyClassName: 'tsc',
                text: 'Join KeyWord',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'JackpotWinners',
                TrOnlyClassName: 'tsc',
                text: 'Jackpot Winners',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'registrationChannel',
                TrOnlyClassName: 'tsc',
                text: 'Registration Channel',
                className: 'tsc',
                align: 'left'
            },
            {
                key: "action",
                text: "Remarks",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center" >
                            <button className=" btn-primary"
                                title="Remarks"
                                style={
                                    { marginRight: '10px' }}
                                onClick={
                                    () => { this.toggleModalCreate(record) }} >
                                <span className="" > Click here </span>
                            </button>

                        </Fragment>
                    );
                }
            }

        ]

        this.columns2 = [
            {
                key: 'mticketRate',
                TrOnlyClassName: 'tsc',
                text: 'Ticket Rate',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mnetCashValue',
                TrOnlyClassName: 'tsc',
                text: 'Net Cash Value',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mjackpotAmount',
                TrOnlyClassName: 'tsc',
                text: 'JackpotAmount',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'mminiJackpotWinner',
                TrOnlyClassName: 'tsc',
                text: 'MiniJackPot',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'mbonus',
                TrOnlyClassName: 'tsc',
                text: 'Bonus',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'bonus_dates',
                TrOnlyClassName: 'tsc',
                text: 'Bonus Date',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mbonusAllowed',
                TrOnlyClassName: 'tsc',
                text: 'Bnus Allowed',
                className: 'tsc',
                align: 'left'
            },
            {
                key: "action",
                text: "Blacklist?",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center" >
                            <button className=" btn-danger"
                                title="Blacklist?"
                                style={
                                    { marginRight: '10px' }}
                                onClick={
                                    () => {
                                        if (window.confirm('Are you sure you want to add this customer to blacklist?'))
                                            this.onSubmitblacklist(record)
                                    }
                                } >

                                <span className="" > Click here </span>
                            </button>

                        </Fragment>
                    );
                }
            }


        ]

        this.columns3 = [
            {
                key: 'mfreeEntries',
                TrOnlyClassName: 'tsc',
                text: 'Free Entiries',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'msupaFreeEntries',
                TrOnlyClassName: 'tsc',
                text: 'Super Free Entiries',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mtimeCreated',
                TrOnlyClassName: 'tsc',
                text: 'TIme Active',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mactive',
                TrOnlyClassName: 'tsc',
                text: 'Active',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'dates2',
                TrOnlyClassName: 'tsc',
                text: 'Last Date Active',
                className: 'tsc',
                align: 'left'
            },
            {
                key: 'mpromoCode',
                TrOnlyClassName: 'tsc',
                text: 'Promotion Code',
                className: 'tsc',
                align: 'left'
            },

            {
                key: 'mticketBundle',
                TrOnlyClassName: 'tsc',
                text: 'Ticket Bundled',
                className: 'tsc',
                align: 'left'
            }
        ]
        this.config = {
            key_column: 'tsc',
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: false,
            pagination: 'basic',
            page_size: 10,
            show_info: false,
            show_length_menu: false,
            language: {
                loading_text: 'Please be patient while data loads...'
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            oncall: true,
            call_status: "On Call",
            remarks: "Pending",
            isOpen: false,
            isOpenModel: false,
            call_value: [
                { value: 'On Call', label: 'On Call' }],

            remark_value: [

                { value: 'Pending', label: 'Pending' }],
            showComponent: false,
            hideComponent: false,
            data: []
        }
    }

    onSubmitblacklist(record) {


        let formData = {
            "mobile": record.phone
        }
        console.log("DATA", JSON.stringify(formData))
        // this.setState({ isLoading: true });

        axios.post(baseURL + 'createBlackList', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            console.log("bayo", response)
            // eslint-disable-next-line
            if (response.data.success == true) {
                console.log("records", formData)
                this.setState({ isShowError: true, isLoading: false });


                alert(response.data.message)

            } else {
                alert(response.data.message)

                this.setState({ isShowError: true, isLoading: false });

                // window.setTimeout(function () {
                //     window.location.href = "/session";
                // }, 2000);
            }

        })
            .catch(error => {
                console.log('bayoo', error.response)

                this.setState({ isShowError: true, isLoading: false });


                alert(error.response.data.message)

            });

    }

    onSubmitAfterCallingCustomer(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Thanks for your time and response to luckybox Tanzania.",
        }

        this.setState({ isLoadingCalls: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoadingCalls: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoadingCalls: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message,
                showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoadingCalls: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitAfterCustomerCalling(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Thanks for calling luckybox Tanzania",
        }

        this.setState({ isLoadisLoadingCallsing2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoadisLoadingCallsing2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoadisLoadingCallsing2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" :
                    error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoadisLoadingCallsing2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    componentDidMount() {



        // localStorage.setItem("msisdnrecord", response.data.message.msisdn)


        // alert(localStorage.getItem('phone'))
        this.setState({ isLoading: true })
        axios.get(baseURL + 'customerOneDetails/' + localStorage.getItem('phone'), {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        })
            .then((response) => {
                console.log('bayo', response.data)
                this.setState({
                    admins: response.data,
                    isLoading: false
                },
                    function () {
                        const data
                            = []
                        for (let i = 0; i < this.state.admins.length; i++) {
                            let mbalance
                            let xactive
                            let mail
                            let maccount
                            let phone
                            let mjoiningKeyword
                            // mail = { JackpotWinners: this.state.admins[i].JackpotWinner.toString() }

                            if (this.state.admins[i].account === null) {
                                maccount = { maccount: '____' }
                            } else {
                                maccount = { maccount: this.state.admins[i].account }
                            }
                            mbalance = { mbalance: this.state.admins[i].balance.toString() }
                            const mticketRate = { mticketRate: this.state.admins[i].ticketRate.toString() }
                            const mnetCashValue = { mnetCashValue: this.state.admins[i].netCashValue.toString() }

                            if (this.state.admins[i].msisdn === null) {
                                phone = { phone: '_' }
                            } else {
                                phone = { phone: this.state.admins[i].msisdn }
                            }

                            if (this.state.admins[i].joiningKeyword === null) {
                                mjoiningKeyword = { mjoiningKeyword: '_' }
                            } else {
                                mjoiningKeyword = { mjoiningKeyword: this.state.admins[i].joiningKeyword }
                            }

                            localStorage.setItem('customerID', this.state.admins[i].id)

                            const mjackpotAmount = { mjackpotAmount: this.state.admins[i].jackpotAmount.toString() }
                            const mfreeEntries = { mfreeEntries: this.state.admins[i].freeEntries.toString() }
                            const mbonusAllowed = { mbonusAllowed: this.state.admins[i].bonusAllowed.toString() }
                            const mticketBundle = { mticketBundle: this.state.admins[i].ticketBundle.toString() }
                            const msupaFreeEntries = { msupaFreeEntries: this.state.admins[i].supaFreeEntries.toString() }
                            const mbonus = { mbonus: this.state.admins[i].bonus.toString() }
                            const mminiJackpotWinner = { mminiJackpotWinner: this.state.admins[i].miniJackpotWinner.toString() }


                            const dates = { dates2: moment.utc(this.state.admins[i].date_last_active).format('DD MMM, YYYY HH:MM') }

                            const bonus_dates = { bonus_dates: moment.utc(this.state.admins[i].bonusExpiryDate).format('DD MMM, YYYY HH:MM') }

                            const mtimeCreated = { mtimeCreated: moment.utc(this.state.admins[i].timeCreated).format('DD MMM, YYYY HH:MM') }

                            xactive = { mactive: this.state.admins[i].active.toString() }

                            data.push(Object.assign(xactive, mjoiningKeyword, maccount, phone, mminiJackpotWinner, mnetCashValue, mjackpotAmount, bonus_dates, mfreeEntries,
                                mbonusAllowed, mticketBundle, msupaFreeEntries, mbonus, bonus_dates, mtimeCreated, mticketRate, mbalance, dates, this.state.admins[i]))
                            this.setState({
                                data: data,
                                number: this.state.admins[i].msisdn
                            })
                        }
                    }
                )
            })



        axios.get(baseURL + 'getcall/' + localStorage.getItem('phone').replaceAll("+", ""), {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        }).then((response) => {
            // alert(JSON.stringify(response))
            if (response.data.total === 0) {
                this.setState({
                    oncall: false,
                    mstatus: response.data.data.length === 0 ? "Not Called" : response.data.data[0].status,
                    mdateStatus: response.data.data.length === 0 ? "Not Called" : response.data.data[0].date_created,

                    isLoading: false
                })
            } else {
                this.setState({
                    oncall: true,
                    mstatus: response.data.data[0].status,
                    isLoading: false
                })

                // alert(response.data.data[0].status)
            }

        })
    }
    closeModalFloat = e => {
        this.setState({
            isOpenModel: false,
        });
    };
    toggleModalFloat = e => {
        // alert("fkk")
        this.setState({
            isOpenModel: true,
        });
    };

    onSubmitQuery(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Hello! Your query has been registered will be attended within 2hrs.\n\nAndika SAL kisha tuma kwenda 15350 \n\nHakikisha una kiasi kisichopungua Tshs 50 kwenye salio lako la kawaida\n\nKwa msaada:0748770101",
        }

        this.setState({ isLoading1: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading1: false });
                    alert(response.data.message)
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading1: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading1: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitPlay(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Andika namba kati ya 1 hadi 6 kisha tuma kwenda 15350\n\nHakikisha una kiasi kisichopungua Tshs 50 kwenye salio lako la kawaida\n\nKwa msaada:0748770100",
        }

        this.setState({ isLoading2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }


    onSubmitDepositTP(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Andika SAL kisha tuma kwenda 15350 \n\nHakikisha una kiasi kisichopungua Tshs 50 kwenye salio lako la kawaida\n\nKwa msaada:0748770101",
        }

        this.setState({ isLoading2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitPlayOnline(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Piga *150*00# \n\nChagua namba 4 lipa kwa M-PESA\n\nChagua 4 weka namba ya Kampuni ambayo ni 001122\n\nWeka kumbukumbu namba ambayo ni namba yako ya bahati kati ya 1 hadi 6\n\nIngiza kiasi cha Tsh 500\n\nThibitisha kwa kuingiza namba yako ya siri.",
        }

        this.setState({ isLoading2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitPlayAirtel(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Piga *150*60#\n\nChagua namba 5 Lipa bili\n\nChagua 6 Bahati Nasibu\n\nAndika 37\n\nWeka kumbukumbu namba ambayo ni namba yako ya bahati kati ya 1 hadi 6\n\nIngiza kiasi cha Tsh 500\n\nThibitisha kwa kuingiza namba yako ya siri.",
        }

        this.setState({ isLoading2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitPlayTigo(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Piga *150*01#\n\nChagua namba 4 lipa bili\n\nChagua 3 Weka namba ya Kampuni ambayo ni 001122\n\nIngiza kumbukumbu namba ambayo ni namba yako ya bahati kati ya 1 hadi 6\n\nIngiza kiasi cha Tsh 500\n\nThibitisha kwa kuingiza namba yako ya siri.",
        }

        this.setState({ isLoading2: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading2: false });
                    alert(response.data.message)
                }, 2000);

            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading2: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading2: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    onSubmitWithdraw(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Andika Toa#kiasi mfano Toa#2000 kisha tuma kwenda 15350\n\nKiwango cha kutoa pesa kinaanzia Tshs 1,000 hadi Tshs 250,000\n\nHakikisha una kiasi kisichopungua Tshs 50 kwenye salio lako la kawaida\n\nKwa msaada:0748770100",
        }

        this.setState({ isLoading3: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading3: false });
                    alert(response.data.message)
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading3: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading3: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }

    toggleModalCreate = e => {
        this.setState({
            isOpen: true,
        });
    };

    closeModalUpload = e => {
        this.setState({
            isOpen: false,
        });
    };

    onSubmitDeposit(e) {
        e.preventDefault();

        let formData = {
            "msisdn": localStorage.getItem('phone'),
            "message": "Andika Tiketi#kiasi mfano Tiketi#2000 tuma kwenda 15350 kisha thibitisha kwa kuingiza namba yako ya siri\n\nKiwango cha tiketi moja ni Tshs 500\n\nHakikisha una kiasi kisichopungua Tshs 50 kwenye salio lako la kawaida\n\nKwa msaada:0748770100",
        }

        this.setState({ isLoading4: true });
        axios.post(baseURL + 'smsresponse', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpenModel: false, isLoading4: false });
                    alert(response.data.message)
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, });
                window.setTimeout(() => {
                    this.setState({
                        isLoading4: false,
                        isShowError: false,
                        statusMessage: "",
                        isOpenModel: false,
                        showError: false
                    });
                    alert(response.data.message)
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading4: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });

                alert(this.state.statusMessage)
            }, 2000);
        })
    }



    onSubmitRemark() {
        // e.preventDefault();
        this.setState({ isLoading4: true });
        let formData = {
            mobile: localStorage.getItem('phone').replaceAll("+", ""),
            status: this.state.call_status,
            call_type: "unkwown_call",
            name: localStorage.getItem("name"),
            msisdn: localStorage.getItem("msisdnrecord"),
            remarks: this.state.remarks
        }
        this.setState({ isLoading4: true });
        axios.post(baseURL + 'remark', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {

            if (response.data.status) {

                this.setState({ statusMessage: response.data.message, isLoading4: false, showError: false, isShowError: true });
                window.scrollTo(0, 0)
                // alert("Success");
                axios.get(baseURL + 'getcall/' + localStorage.getItem('phone').replaceAll("+", ""), {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                }).then((response) => {
                    if (response.data.total === 0) {
                        this.setState({
                            oncall: false,
                            mstatus: response.data.data.length === 0 ? "Not Called" : response.data.data[0].status,
                            isLoading: false
                        })
                    } else {
                        this.setState({
                            oncall: true,
                            mstatus: response.data.data[0].status,
                            isLoading: false
                        })
                        // alert(response.data.data[0].status)
                    }
                })
            } else {
                this.setState({ statusMessage: response.data.message, isLoading4: false, showError: true, isShowError: false, });
            }
        }).catch((error) => {
            this.setState({ isLoading4: false });

            alert(JSON.stringify(error.response))
        })
    }


    onSubmitRemarkUpdate() {
        // e.preventDefault();
        this.setState({ isLoading4: true });
        let formData = {
            mobile: localStorage.getItem('phone').replaceAll("+", ""),
            status: this.state.call_status,
            call_type: this.state.call_type,
            conversation_summary: this.state.message,
            remarks: this.state.remarks
        }


        // alert(JSON.stringify(formData))
        this.setState({ isLoading4: true });
        axios.post(baseURL + 'remarkupdate', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            this.closeModalUpload();
            alert("Feedback send");




            this.setState({ statusMessage: response.data.message, isLoading4: false, showError: false, isShowError: true });
            window.scrollTo(0, 0)

            axios.get(baseURL + 'getcall/' + localStorage.getItem('phone').replaceAll("+", ""), {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }
            }).then((response) => {
                if (response.data.total === 0) {


                    this.setState({
                        oncall: false,
                        mstatus: response.data.data.length === 0 ? "Not Called" : response.data.data[0].status,
                        isLoading: false
                    })
                } else {
                    this.closeModalUpload();

                    this.setState({
                        oncall: true,
                        mstatus: response.data.data[0].status,
                        isLoading: false
                    })

                    // alert(response.data.data[0].status)
                }

            })

            // } else {
            //     this.setState({ statusMessage: response.data.message, isLoading4: false, showError: true, isShowError: false, });
            // }
        }).catch((error) => {
            this.setState({ isLoading4: false });

            alert(JSON.stringify(error.response))
        })
    }


    handleChange = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    call_status: value.value.toString(),
                    call_value: [
                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeMessage = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }


    handleChangeRemarks = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    remarks: value.value.toString(),
                    remark_value: [

                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeCallType = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    call_type: value.value.toString(),
                    call_type_value: [

                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };


    render() {
        // console.log("Load", isLoading);
        return (
            <div>
                <>
                    <Table>

                        <Modal
                            isOpen={this.state.isOpen}
                            onRequestClose={e => {
                                this.closeModalUpload(e);
                            }}
                            contentLabel="My dialog"
                            className="mymodalclient"
                            onAfterOpen={() => {
                                document.body.style.overflow = 'hidden';
                            }}
                            onAfterClose={() => {
                                document.body.removeAttribute('style');
                            }}
                            overlayClassName="myoverlay"
                            closeTimeoutMS={500}
                        >


                            <h4><b>Add Remark </b></h4>
                            <br />
                            <label>Call Type</label>
                            <Select
                                isClearable
                                options={options_3}
                                // onInputChange={this.loadOptions}
                                placeholder="Call type"
                                autosize={true}
                                onChange={this.handleChangeCallType}
                                value={this.state.call_type_value}
                                isLoading={this.state.isLoading}
                                menuPortalTarget={document.body}
                                name="name"
                            />
                            <br />
                            <label>Call Status</label>
                            <Select
                                isClearable
                                options={options}
                                // onInputChange={this.loadOptions}
                                placeholder="Call Status"
                                autosize={true}
                                onChange={this.handleChange}
                                value={this.state.call_value}
                                menuPortalTarget={document.body}
                                name="name"
                            />

                            <br />

                            <label>Remark</label>


                            <Select
                                isClearable
                                options={options_2}
                                // onInputChange={this.loadOptions}
                                placeholder="Remarks"
                                autosize={true}
                                onChange={this.handleChangeRemarks}
                                value={this.state.remark_value}
                                isLoading={this.state.isLoading}
                                menuPortalTarget={document.body}
                                name="name"
                            />
                            <br />

                            <div className="form-group">
                                <textarea name="message" style={{ paddingTop: '20px' }} onChange={this.handleChangeMessage}
                                    className="col-md-12" placeholder="Call summary"
                                    id="message" cols="col-md-1" rows="3"></textarea>
                            </div><br />
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <button
                                        onClick={this.onSubmitRemarkUpdate}
                                        className="btn btn-primary btn-sm"
                                    >
                                        {this.state.isLoading4 ? "Sending" : "Submit"}


                                    </button>
                                </div>
                            </div>
                        </Modal>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>

                                    <Modal
                                        isOpen={this.state.isOpenModel}
                                        onRequestClose={e => {
                                            this.closeModalFloat(e);
                                        }}
                                        contentLabel="My dialog"
                                        className="mymodalclient"
                                        onAfterOpen={() => {
                                            document.body.style.overflow = 'hidden';
                                        }}
                                        onAfterClose={() => {
                                            document.body.removeAttribute('style');
                                        }}
                                        overlayClassName="myoverlay"
                                        closeTimeoutMS={500}
                                    >
                                        <MDBCloseIcon onClick={this.closeModalFloat} />
                                        <h4><b>Send Responses</b></h4><br />

                                        <form className="form" onSubmit={this.onSubmitAfterCustomerCalling}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoadisLoadingCallsing2 ? "Sending Please Wait..." : "When Customer Calls"}
                                            </button>
                                        </form><br />


                                        <form className="form" onSubmit={this.onSubmitAfterCallingCustomer}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoadingCalls ? "Sending Please Wait..." : "After Calling Customer"}
                                            </button>
                                        </form><br />


                                        <form className="form" onSubmit={this.onSubmitQuery}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading1 ? "Sending Please Wait..." : "Customer Support Queries Escalation Ticketing"}
                                            </button>
                                        </form><br />

                                        <form className="form" onSubmit={this.onSubmitPlay}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading2 ? "Sending Please Wait..." : "How to Play Via Shortcode"}
                                            </button>
                                        </form><br />

                                        <form className="form" onSubmit={this.onSubmitPlayOnline}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading3 ? "Sending Please Wait..." : "How To play via M-pesa"}
                                            </button>
                                        </form><br />
                                  
                                        <form className="form" onSubmit={this.onSubmitPlayAirtel}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading2 ? "Sending Please Wait..." : "How To play via Airtel money "}
                                            </button>
                                        </form><br />



                                        <form className="form" onSubmit={this.onSubmitPlayTigo}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading2 ? "Sending Please Wait..." : "How To play via Tigopesa"}
                                            </button>
                                        </form><br />


                                        <form className="form" onSubmit={this.onSubmitWithdraw}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading3 ? "Sending Please Wait..." : "How to Withdraw via SMS"}
                                            </button>
                                        </form><br />
                                        <form className="form" onSubmit={this.onSubmitDeposit}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading4 ? "Sending Please Wait..." : "How To deposit via SMS"}
                                            </button>
                                        </form><br />
                                      
                                      
                                        <form className="form" onSubmit={this.onSubmitDepositTP}>
                                            <button
                                                type="submit"
                                                color='primary'
                                                outline
                                                className="btn-sm">
                                                {this.state.isLoading3 ? "Sending Please Wait..." : "How to check balance"}
                                            </button>
                                        </form><br />

                                    </Modal>
                                    <Link to='/user'>
                                        <Button
                                            className='float-right btn btn-sm'
                                            color='primary' outline
                                        > <i className='fa  fa-arrow-left' /> Back
                                        </Button><br />
                                    </Link>
                                    <div className='panel-body'>

                                        <div className='col-md-12'>

                                            <div className='row'>
                                                <div className='col-md-3'>

                                                    <Link to='/game'>
                                                        <Button
                                                            className='btn btn-sm'
                                                            color='primary' outline
                                                        >Bets: Games
                                                        </Button><br />
                                                    </Link>
                                                </div>

                                                <div className='col-md-3'>
                                                    <Link to='/statement'>
                                                        <Button
                                                            className='btn btn-sm'
                                                            color='primary' outline
                                                        >Statements
                                                        </Button><br />
                                                    </Link>
                                                </div>

                                                <div className='col-md-4'>
                                                    <Link to='/invalidmessage'>
                                                        <Button
                                                            className='btn btn-sm'
                                                            color='primary' outline
                                                        > Invalid Messages
                                                        </Button><br />
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4>Calling status: <b>{this.state.mstatus}</b>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/> Last time being called <b>{moment.utc(this.state.mdateStatus).format('DD MMM, YYYY HH:MM')}</b></h4>
                                            <br />

                                        </div>
                                        <div className="row">

                                            <div className="col-4">
                                                <h4>Phone# <b>{localStorage.getItem('phone')}</b></h4><br />
                                            </div>
                                            <div className="col-4">
                                                <a href="#" style={{ fontSize: "16px" }} onClick={() => { this.toggleModalFloat() }}>Send Response?</a>
                                            </div>

                                            {this.state.oncall === false ?
                                                <div className="col-4">
                                                    <a href="#" style={{ fontSize: "16px" }} onClick={() => { this.onSubmitRemark() }}>
                                                        {this.state.isLoading4 ? "Sending" : "Are you on Call?"}</a>
                                                </div>
                                                :
                                                <div className="col-4">
                                                    <h4><b>{this.state.mstatus}</b></h4> :
                                                    <br />
                                                    {/* 
                                                <a href="#" style={{ fontSize: "16px" }} onClick={() => { this.toggleModalFloat() }}>{this.state.isLoading1 ? "Sending Please Wait..." : "On Call?"}</a> */}
                                                </div>
                                            }
                                        </div>


                                        <div className='row'>

                                            <div className='col-md-2'>

                                                <br /><br />
                                                <Link to='/withdrawals_customer'>
                                                    <Button
                                                        className='btn btn-sm'
                                                        color='primary' outline
                                                    > Withdrawals
                                                    </Button><br />
                                                </Link>
                                                <br />
                                                <Link to='/deposits_customer'>
                                                    <Button
                                                        className='btn btn-sm'
                                                        color='primary' outline
                                                    > Deposits
                                                    </Button><br />
                                                </Link>
                                                <br />
                                                {/* <Link to='/mtndepositsrequests'>
                                                    <Button
                                                        className='btn btn-sm'
                                                        color='primary' outline
                                                    > MTN Deposits
                                                    </Button><br />
                                                </Link>
                                                <br /> */}


                                                {localStorage.getItem('phone_2') === "false" ?
                                                    <Link to='/allmessages'>
                                                        <Button
                                                            className='btn btn-sm'
                                                            color='primary' outline
                                                        > All Messages
                                                        </Button><br />
                                                    </Link>
                                                    :
                                                    <Link to='/outgoing'>
                                                        <Button
                                                            className='btn btn-sm'
                                                            color='primary' outline
                                                        > All Messages
                                                        </Button><br />
                                                    </Link>

                                                }



                                            </div>

                                            <div className='col-md-10'>

                                                <ReactDatatable
                                                    config={this.config}
                                                    records={this.state.data}
                                                    id='tsc'
                                                    columns={this.columns}
                                                    loading={this.state.isLoading}
                                                    extraButtons={this.extraButtons}
                                                />

                                                <br /><br />
                                                <ReactDatatable
                                                    config={this.config}
                                                    records={this.state.data}
                                                    id='tsc'
                                                    columns={this.columns2}
                                                    loading={this.state.isLoading}
                                                    extraButtons={this.extraButtons}
                                                />

                                                <br /><br />
                                                <ReactDatatable
                                                    config={this.config}
                                                    records={this.state.data}
                                                    id='tsc'
                                                    columns={this.columns3}
                                                    loading={this.state.isLoading}
                                                    extraButtons={this.extraButtons}
                                                />
                                            </div>

                                            {/* <CustomerCalledStatus/> */}
                                        </div>

                                    </div>

                                </CardBody>

                            </Card>
                        </Col>
                    </Table>
                </>
            </div >

        )
    }
}
